module.exports = Object.freeze({
  pending: 'pending',
  received: 'received',
  canceled: 'canceled',
  refunded: 'refunded',
  partiallyRefunded: 'partially_refunded',
  canceledByUser: 'canceled_by_user',
  canceledByPsp: 'canceled_by_psp',
  authorized: 'authorized'
});
